const UpdateEmail = require("./containers/UpdateEmail");
const Authenticate = require("../utils").authenticate;

module.exports = {
    path: "/update-email",
    component: Authenticate(UpdateEmail),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/update-email/index.js